"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoutEnemy = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _colliderComponent2 = require("../../components/collider/collider-component");
var _eventBusComponent2 = require("../../components/events/event-bus-component");
var _healthComponent2 = require("../../components/health/health-component");
var _botScoutInputComponent = require("../../components/input/bot-scout-input-component");
var _horizontalMovementComponent2 = require("../../components/movement/horizontal-movement-component");
var _verticalMovementComponent2 = require("../../components/movement/vertical-movement-component");
var CONFIG = _interopRequireWildcard(require("../../config"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _isInitialized = /*#__PURE__*/new WeakMap();
var _inputComponent = /*#__PURE__*/new WeakMap();
var _horizontalMovementComponent = /*#__PURE__*/new WeakMap();
var _verticalMovementComponent = /*#__PURE__*/new WeakMap();
var _healthComponent = /*#__PURE__*/new WeakMap();
var _colliderComponent = /*#__PURE__*/new WeakMap();
var _eventBusComponent = /*#__PURE__*/new WeakMap();
var _shipSprite = /*#__PURE__*/new WeakMap();
var _shipEngineSprite = /*#__PURE__*/new WeakMap();
class ScoutEnemy extends Phaser.GameObjects.Container {
  constructor(scene, x, y) {
    super(scene, x, y, []);
    _classPrivateFieldInitSpec(this, _isInitialized, void 0);
    _classPrivateFieldInitSpec(this, _inputComponent, null);
    _classPrivateFieldInitSpec(this, _horizontalMovementComponent, null);
    _classPrivateFieldInitSpec(this, _verticalMovementComponent, null);
    _classPrivateFieldInitSpec(this, _healthComponent, null);
    _classPrivateFieldInitSpec(this, _colliderComponent, null);
    _classPrivateFieldInitSpec(this, _eventBusComponent, null);
    _classPrivateFieldInitSpec(this, _shipSprite, void 0);
    _classPrivateFieldInitSpec(this, _shipEngineSprite, void 0);
    _classPrivateFieldSet(_isInitialized, this, false);
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.body.setSize(24, 24);
    this.body.setOffset(-12, -12);
    _classPrivateFieldSet(_shipSprite, this, scene.add.sprite(0, 0, 'scout', 0));
    _classPrivateFieldSet(_shipEngineSprite, this, scene.add.sprite(0, 0, 'scout_engine').setFlipY(true));
    _classPrivateFieldGet(_shipEngineSprite, this).play('scout_engine');
    this.add([_classPrivateFieldGet(_shipEngineSprite, this), _classPrivateFieldGet(_shipSprite, this)]);
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
    }, this);
  }
  get colliderComponent() {
    return _classPrivateFieldGet(_colliderComponent, this);
  }
  get healthComponent() {
    return _classPrivateFieldGet(_healthComponent, this);
  }
  get shipAssetKey() {
    return 'scout';
  }
  get shipDestroyedAnimationKey() {
    return 'scout_destroy';
  }
  init(eventBusComponent) {
    _classPrivateFieldSet(_eventBusComponent, this, eventBusComponent);
    _classPrivateFieldSet(_inputComponent, this, new _botScoutInputComponent.BotScoutInputComponent(this));
    _classPrivateFieldSet(_horizontalMovementComponent, this, new _horizontalMovementComponent2.HorizontalMovementComponent(this, _classPrivateFieldGet(_inputComponent, this), CONFIG.ENEMY_SCOUT_MOVEMENT_HORIZONTAL_VELOCITY));
    _classPrivateFieldSet(_verticalMovementComponent, this, new _verticalMovementComponent2.VerticalMovementComponent(this, _classPrivateFieldGet(_inputComponent, this), CONFIG.ENEMY_SCOUT_MOVEMENT_VERTICAL_VELOCITY));
    _classPrivateFieldSet(_healthComponent, this, new _healthComponent2.HealthComponent(CONFIG.ENEMY_SCOUT_HEALTH));
    _classPrivateFieldSet(_colliderComponent, this, new _colliderComponent2.ColliderComponent(_classPrivateFieldGet(_healthComponent, this), _classPrivateFieldGet(_eventBusComponent, this)));
    _classPrivateFieldGet(_eventBusComponent, this).emit(_eventBusComponent2.CUSTOM_EVENTS.ENEMY_INIT, this);
    _classPrivateFieldSet(_isInitialized, this, true);
  }
  reset() {
    var _classPrivateFieldGet2, _classPrivateFieldGet3, _classPrivateFieldGet4;
    this.setActive(true);
    this.setVisible(true);
    (_classPrivateFieldGet2 = _classPrivateFieldGet(_healthComponent, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.reset();
    _classPrivateFieldGet(_inputComponent, this).startX = this.x;
    (_classPrivateFieldGet3 = _classPrivateFieldGet(_verticalMovementComponent, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.reset();
    (_classPrivateFieldGet4 = _classPrivateFieldGet(_horizontalMovementComponent, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.reset();
  }
  update(ts, dt) {
    var _classPrivateFieldGet5, _classPrivateFieldGet7, _classPrivateFieldGet8, _classPrivateFieldGet9;
    if (!_classPrivateFieldGet(_isInitialized, this)) return;
    if (!this.active) return;
    if ((_classPrivateFieldGet5 = _classPrivateFieldGet(_healthComponent, this)) !== null && _classPrivateFieldGet5 !== void 0 && _classPrivateFieldGet5.isDead) {
      var _classPrivateFieldGet6;
      this.setActive(false);
      this.setVisible(false);
      (_classPrivateFieldGet6 = _classPrivateFieldGet(_eventBusComponent, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.emit(_eventBusComponent2.CUSTOM_EVENTS.ENEMY_DESTROYED, this);
    }
    (_classPrivateFieldGet7 = _classPrivateFieldGet(_inputComponent, this)) === null || _classPrivateFieldGet7 === void 0 || _classPrivateFieldGet7.update();
    (_classPrivateFieldGet8 = _classPrivateFieldGet(_horizontalMovementComponent, this)) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.update();
    (_classPrivateFieldGet9 = _classPrivateFieldGet(_verticalMovementComponent, this)) === null || _classPrivateFieldGet9 === void 0 || _classPrivateFieldGet9.update();
  }
}
exports.ScoutEnemy = ScoutEnemy;